import{a}from"./chunk-HNLFKTAJ.js";import{a as e}from"./chunk-FEIY7W7S.js";var c={};e(c,{getMatches:()=>t});async function t(){return a({__tauriModule:"Cli",message:{cmd:"cliMatches"}})}export{t as a,c as b};
